/**
 * Module dependencies.
 */

import { FormList } from 'app/components/organisms/crud/form-types';
import { requiredRule } from 'app/core/utils/field-rules';
import { TFunction } from 'react-i18next';

/**
 * Export `formFields`.
 */

export const formFields = (translate: TFunction): FormList => [
  {
    type: 'selectField',
    name: 'driverId',
    rules: requiredRule(translate),
    label: translate('common.labels.driver'),
    options: [
      {
        value: 'glintt',
        label: 'Glintt Driver'
      }
    ]
  },
  {
    type: 'inputField',
    name: 'name',
    label: translate('common.labels.name'),
    rules: undefined
  }
];
